<template>
  <!-- Corpo da mensagem é SEMPRE texto puro ({{ }}), nunca v-html. -->
  <div
    v-if="isSystem"
    class="customer-chat-system"
  >
    <span class="customer-chat-system-text">{{ message.body }}</span>
  </div>
  <div
    v-else
    class="chat"
    :class="{ 'chat-left': isCustomer }"
  >
    <div class="chat-body">
      <div
        class="chat-content customer-chat-bubble"
        :class="{
          'customer-chat-bubble--other-staff': isStaff && !isOwn,
          'customer-chat-bubble--failed': isFailed,
        }"
      >
        <small
          v-if="senderText"
          class="customer-chat-sender"
        >{{ senderText }}</small>
        <p
          v-if="hasBody"
          class="customer-chat-text"
        >{{ message.body }}</p>
        <p
          v-else
          class="customer-chat-text font-italic"
        >Mensagem removida</p>
        <small
          class="customer-chat-meta"
          :title="fullDate"
        >
          {{ time }}
          <!-- Entrega, como no WhatsApp: relógio enviando, ✓ enviada, ✓✓ lida pelo cliente. -->
          <span
            v-if="delivery && delivery !== deliveryError"
            class="customer-chat-delivery"
            :class="`customer-chat-delivery--${delivery}`"
            role="img"
            :aria-label="deliveryLabel"
            :title="deliveryLabel"
          >
            <feather-icon
              v-if="delivery === deliverySending"
              icon="ClockIcon"
              size="12"
            />
            <svg
              v-else
              width="20"
              height="14"
              viewBox="0 0 20 16"
              fill="none"
              aria-hidden="true"
            >
              <path
                v-if="delivery === deliveryRead"
                d="M1 8.5l3.5 3.5L12 4.5"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                :d="delivery === deliveryRead ? 'M7 8.5l3.5 3.5L18 4.5' : 'M4 8.5l3.5 3.5L15 4.5'"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </small>
      </div>
      <div
        v-if="isFailed"
        class="customer-chat-failed-actions"
      >
        <small class="text-danger">{{ message.errorMessage || 'Falha ao enviar.' }}</small>
        <b-link
          class="ml-50"
          @click="$emit('retry', message)"
        >
          <small>Reenviar</small>
        </b-link>
        <b-link
          class="ml-50 text-muted"
          @click="$emit('discard', message)"
        >
          <small>Descartar</small>
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import {
  LOCAL_STATUS_SENDING,
  LOCAL_STATUS_ERROR,
  DELIVERY_SENDING,
  DELIVERY_SENT,
  DELIVERY_READ,
  DELIVERY_ERROR,
  deliveryStatus,
  isOwnMessage,
  senderLabel,
} from '../utils/messages'
import { formatTime, formatDateTime } from '../utils/format'

export default {
  components: {
    BLink,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    myPrincipal: {
      type: String,
      default: null,
    },
    // Até onde o cliente leu: ✓✓ nas mensagens do atendente até este seq.
    customerReadSeq: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      deliverySending: DELIVERY_SENDING,
      deliveryRead: DELIVERY_READ,
      deliveryError: DELIVERY_ERROR,
    }
  },
  computed: {
    isSystem() {
      return this.message.senderType === 'SYSTEM'
    },
    isCustomer() {
      return this.message.senderType === 'CUSTOMER'
    },
    isStaff() {
      return this.message.senderType === 'STAFF'
    },
    // Otimistas ainda não têm senderPrincipal confirmado; são sempre minhas.
    isOwn() {
      return !!this.message.localStatus || isOwnMessage(this.message, this.myPrincipal)
    },
    senderText() {
      const label = senderLabel(this.message)
      if (this.isStaff && this.isOwn) return label ? `${label} (você)` : 'Você'
      return label
    },
    hasBody() {
      return typeof this.message.body === 'string' && this.message.body.length > 0
    },
    isSending() {
      return this.message.localStatus === LOCAL_STATUS_SENDING
    },
    isFailed() {
      return this.message.localStatus === LOCAL_STATUS_ERROR
    },
    delivery() {
      return deliveryStatus(this.message, this.customerReadSeq)
    },
    deliveryLabel() {
      return {
        [DELIVERY_SENDING]: 'Enviando',
        [DELIVERY_SENT]: 'Enviada',
        [DELIVERY_READ]: 'Lida pelo cliente',
      }[this.delivery] || ''
    },
    time() {
      return formatTime(this.message.createdAt)
    },
    fullDate() {
      return formatDateTime(this.message.createdAt)
    },
  },
}
</script>
